var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRevenueVendors(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52.059,
    height: 54.505,
    viewBox: "0 0 52.059 54.505",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5695",
    "data-name": "Group 5695",
    transform: "translate(-1785.668 -213.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6882",
    "data-name": "Path 6882",
    d: "M26.476,8.417m-9.029,0c0,2.992,4.042,5.417,9.029,5.417S35.5,11.409,35.5,8.417,31.462,3,26.476,3s-9.029,2.425-9.029,5.417v7.223c0,2.992,4.043,5.417,9.029,5.417S35.5,18.633,35.5,15.641V8.417M17.447,15.641v7.223c0,2.992,4.043,5.417,9.029,5.417S35.5,25.856,35.5,22.864V15.641M17.447,22.864v7.223c0,2.992,4.043,5.417,9.029,5.417S35.5,33.08,35.5,30.087V22.864M10.223,13.835H5.709a2.709,2.709,0,0,0,0,5.417H7.515a2.709,2.709,0,1,1,0,5.417H3m3.612,0v1.806m0-14.447v1.806",
    transform: "translate(1783.418 232)",
    fill: "none",
    stroke: "#dde4eb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6884",
    "data-name": "Path 6884",
    d: "M6.246,19.229V17.606H3L17.606,3,32.212,17.606H28.966v11.36a3.246,3.246,0,0,1-3.246,3.246H17.958m4.517,0V22.475a3.246,3.246,0,0,0-3.246-3.246H15.983a3.246,3.246,0,0,0-3.246,3.246",
    transform: "translate(1804.766 211.5)",
    fill: "none",
    stroke: "#f4f6f8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevenueVendors);
export default __webpack_public_path__ + "static/media/revenue-vendors.720dd63a.svg";
export { ForwardRef as ReactComponent };